import { Component, OnInit, Input, OnChanges, ViewContainerRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';

import { Observable } from 'rxjs/Observable';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { MessageService } from 'app/services/messages.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { Communication } from 'app/entities/details/contactinformation/communication.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ContactService } from 'app/entities/details/contactinformation/contact.service';
import { AddContactInformationComponent } from 'app/entities/details/contactinformation/addcontactinformation/addcontactinformation.component';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmationdialog/confirmation-dialog.component';

@Component({
  selector: 'contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.css']
})

/**
 * Component to render the client contact information.
 */
export class ContactInformationComponent implements OnInit, OnChanges {
  @Input()
  entityIdDetails: EntityIdDetails;

  dialogRef: MdDialogRef<any>;
  communicationTypes: ApplicationValue[];
  communicationByTypeMapping = new Map<String, Array<Communication>>();

  contacts = [];

  constructor(
    public dialog: MdDialog,
    private warmUpService: WarmUpService,
    private snackBarService: SnackBarService,
    private contactService: ContactService,
    private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit() {
    this.loadCommunicationTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.COMMUNICATION_TYPE));
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.contactService.loadContactDetails(this.entityIdDetails.orgId, this.entityIdDetails.entityType).subscribe(
        response => {
          if (response.flagResult) {
            this.updateContacts(response.arrResult);
          }
        }
      )
    }
  }

  loadCommunicationTypes(communicationTypeValues: any) {
    if (communicationTypeValues instanceof Observable) {
      communicationTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.communicationTypes = response.values;
        }
      );
    } else {
      this.communicationTypes = communicationTypeValues;
    }
    if (this.communicationTypes) {
      for (const communicationType of this.communicationTypes) {
        this.communicationByTypeMapping[communicationType.id] = communicationType.name;
      }
    }
  }

  updateContacts(contactInformations: Array<Communication>) {
    this.contacts = [
      { id: 'mobile_phone', name: 'Mobile phone', values: [] },
      { id: 'private_email', name: 'Private email', values: [] },
      { id: 'work_email', name: 'Work email', values: [] },
      { id: 'work_phone', name: 'Work phone', values: [] }
    ];

    for (const contact of contactInformations) {
      if (this.communicationByTypeMapping[contact.type] === 'Work email') {
        this.contacts[2].values.push(contact);
      } else if (this.communicationByTypeMapping[contact.type] === 'Private email') {
        this.contacts[1].values.push(contact);
      } else if (this.communicationByTypeMapping[contact.type] === 'Mobile phone') {
        this.contacts[0].values.push(contact);
      } else if (this.communicationByTypeMapping[contact.type] === 'Work phone') {
        this.contacts[3].values.push(contact);
      }
    }
  }

  openAddContactInfoDialog(action: string, selectedContact: Communication, index: number) {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(AddContactInformationComponent, config);
    this.dialogRef.componentInstance.contactTypes = this.communicationTypes;
    this.dialogRef.componentInstance.action = action;
    this.dialogRef.componentInstance.selectedContact = selectedContact;
    this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
    this.dialogRef.componentInstance.entityType = this.entityIdDetails.entityType;
    this.dialogRef.afterClosed().subscribe(response => {
      this.dialogRef = null;
      if (response) {
        this.updateContactList(response, action, index);
      }
    });
  }

  openDeleteContactDialog(contact: Communication) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
    this.dialogRef.componentInstance.message = 'Are you sure you want to delete this contact?';
    this.dialogRef.componentInstance.title = 'Delete Contact';
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteContact(contact);
      }
    });
  }

  deleteContact(contact: Communication): void {
    this.contactService.deleteContact({ commId: contact.id })
      .subscribe(response => {
        this.updateContactList(contact, 'Delete');
        this.callSnackBarService(response);
      }, err => {
        this.callSnackBarService(err);
      }
      );
  }

  updateContactList(contact: Communication, action: string, index?: number) {
    for (let value of this.contacts) {
      if (value.name == this.communicationByTypeMapping[contact.type]) {
        if (action === 'Delete') {
          value.values.splice(value.values.indexOf(contact), 1);
        } else if (action === 'Add') {
          value.values.push(contact);
        } else if (action == 'Edit') {
          value.values[index] = contact;
        }
      }
    }
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response, MessageService.DELETE_CONTACT_SUCCES, MessageService.CONTACT_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/contactinformation/contact-information.component.ts